import React, { useState, createContext } from "react";

export const SearchBarContext = createContext({});

function SearchBarProvider({ children }) {
  const [callBackState, setCallBackState] = useState();
  const [search, setSearch] = useState();

  return (
    <SearchBarContext.Provider
      value={{
        search,
        setSearch,
        callBackState,
        setCallBackState,
      }}
    >
      {children}
    </SearchBarContext.Provider>
  );
}

export default SearchBarProvider;
